module.exports = __webpack_public_path__ + "img/13.05467999.png";